// Nombre del PDF de una ocurrencia: "<sucursal> - <formulario>.pdf", sin los caracteres que un sistema de archivos
// no admite.
export function pdfFilename (payload) {
  const sanitize = (value) => String(value || '').replace(/[/\\:*?"<>|]/g, '-')
  return `${sanitize(payload.location_name)} - ${sanitize(payload.form_name)}.pdf`
}
